<template>
	<div>
		<div class="mt-4 pt-4">
			<h1>Settings</h1>
			<div class="mt-4">
				<div class="row">
					<div class="col-12">
						<div class="card">
							<div class="card-body">
								<div class="table-responsive">
									<table class="table table-striped">
										<thead>
											<tr class="text-end">
												<th colspan="4">
													<button
														class="btn btn-outline-info"
														data-bs-toggle="modal"
														data-bs-target="#forms"
														v-on:click="refresh = Math.random(); setId = 0"
														id="triggerModals"
													>Create new setting variable</button>
												</th>
											</tr>
											<tr>
												<th>Title</th>
												<th>Group</th>
												<th>Value</th>
												<th>Action</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="s in settings" :key="s.ID">
												<td>{{ s.title }}</td>
												<td>{{ s.group }}</td>
												<td>{{ s.value }}</td>
												<td>
													<a href="javascript:void(0)"
													class="text-warning"
													data-bs-toggle="modal"
													data-bs-target="#forms"
													v-on:click="update(s.ID)">
														<i class="far fa-edit"></i>
													</a> |
													<a href="javascript:void(0)" class="text-danger" title="Delete" @click="deleteSetting(s.ID)">
														<i class="fa fa-trash"></i>
													</a>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="modal" id="forms" tabindex="-1">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						{{ catCallBack }} Setting
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="closeModal"></button>
					</div>
					<div class="modal-body">
						<Form v-on:callback="formCallback" :setId="setId" :key="refresh"/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
  import Form from './SettingForm.vue'
    export default {
		components: {
			Form
		},
        data() {
            return {
                settings: [],
                refresh: Math.random(),
                setId: 0,
                catCallBack: '',
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                const me = this;
                this.$axios.get(this.$server + 'settings')
                .then(res => {
                    var r = res.data;
                    if (r.success) {
                        me.settings = r.data;
                    }
                });
            },

			update(id) {
				this.setId = id;
				this.refresh = Math.random();
			},

            formCallback(callback) {
				this.catCallBack = callback;
				if (callback == true) { // "need == true" as not empty value will return true
					document.getElementById("closeModal").click(); // manual close for a moment
					this.init();
				}
            },

            deleteSetting(id){
                var c = confirm("Do you really want to delete this record?");
                if (c) {
                    this.$axios.delete(this.$server + 'settings/' + id)
                    .then(res => {
                        var r = res.data;
                        if (r.success) {
                            // reload data
                            this.init();
                        }
                    });
                }
            }
        },
    }
</script>